const accordionContents = document.querySelectorAll(
	'.block-accordion-side-image__content'
);

const resizeGrid = () => {
	if (accordionContents.length) {
		accordionContents.forEach((accordionContent) => {
			accordionContent.style.removeProperty('--marginTop');
			accordionContent.nextElementSibling.style.removeProperty(
				'--marginTop'
			);

			const offset =
				accordionContent.offsetTop -
				accordionContent.nextElementSibling.offsetTop;

			if (offset > 0) {
				accordionContent.style.setProperty(
					'--marginTop',
					`${offset}px`
				);
			} else {
				accordionContent.style.setProperty('--marginTop', `0px`);
			}
		});
	}
};

const accordions = () => {
	if (accordionContents.length) {
		resizeGrid();
	}
};

// GLOBAL APP CONTROLLER
const controller = {
	init() {
		accordions();
	},
	loaded() {
		const setBackgroundSize = () => {
			const backgroundTabBlocks = document.querySelectorAll(
				'.block-tab-side-image'
			);
			if (backgroundTabBlocks.length) {
				backgroundTabBlocks.forEach((backgroundTabBlock) => {

					const content = backgroundTabBlock.querySelector('.block-tab-side-image__content .block-content');
					const spacerInner = backgroundTabBlock.querySelector('.block-tab-side-image__spacer-inner');
					if (content && spacerInner) {
						// Setting the height of the spacer inner to match the content
						const contentHeight = content.offsetHeight; // get the height of the content
						spacerInner.style.height = `${contentHeight}px`; // set the height of the spacer inner
					}

					backgroundTabBlock.style.setProperty(
						'--blockHeight',
						`${backgroundTabBlock.offsetHeight / 16}rem`
					);

					
				});
			}
		};

		setBackgroundSize();

		window.addEventListener('resize', setBackgroundSize);

		document.querySelectorAll('.block-tab-side-image').forEach(block => {
            block.addEventListener('click', () => {
                setBackgroundSize();

				setTimeout(() => {
					setBackgroundSize();
				}, 450);
                resizeGrid();
            });
        });



		// backup to observe the change in the hs form
		const resizeObserver = new ResizeObserver(entries => {
			entries.forEach(entry => {
				setBackgroundSize();
				resizeGrid();
			});
		});
	
		const hbsptForms = document.querySelectorAll('.hbspt-form');
		hbsptForms.forEach(form => {
			resizeObserver.observe(form);
		});


		setTimeout(() => {
			setBackgroundSize();
		}, 1050);
	},
	resized() {
		resizeGrid();
	},
	scrolled() {},
	keyDown() {},
	mouseUp() {},
};
export default controller;
